import React, { useContext, useEffect, useState } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { Dropdown, TextField } from "@fluentui/react";
import QCModalHeader from "../../../../components/Modal/QCModalHeader";
import QCModalFooter from "../../../../components/Modal/QCModalFooter";
import QCFailReasons from "./QCFailReasons";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import themeContext from "../../../../context/theme/ThemeContext";
import { BORDER } from "../../../../constants/Constants";
const dropDownStyles = {
  dropdown: {
    width: "200px",
  },
  dropdownItemsWrapper: {
    maxHeight: "300px",
  },
};
const QCFailModal = (props) => {
  const { patientStudyData } = useContext(studyviewerContext);
  const { getThemeColor,getAlterColor } = useContext(themeContext);
  const { t } = useTranslation();
  const {
    openQcModal,
    setOpenQcModal,
    handleQcReturn,
    qcProviderList,
    studyParentId,
  } = useContext(studyReportContext);
  const [qcReason, setQcReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [enableOtherReason, setEnableOtherReason] = useState(false);
  const [providerId, setProviderId] = useState(null);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const handleChange = (e, item) => {
    setOtherReason(item);
  };

  const handleCancel = () => {
    setOpenQcModal(false);
  };

  const handleProviderDropDownClick = (item) => {
    setProviderId(item.value);
  };

  const PrimaryButtonList = [
    {
      title: t("QC.yes"),
      onclick: () => {
        handleQcReturn(
          studyParentId,
          props.qcData,
          props.keyImages,
          qcReason,
          otherReason,
          providerId,
          setIsError,
          setErrorMessage,
          props.allTextToolAnnotation
        );
      },
    },
  ];
  const DefaultButtonList = [
    {
      title: t("QC.no"),
      onclick: () => setOpenQcModal(false),
    },
  ];
  useEffect(() => {
    if (qcReason === "Other") {
      setEnableOtherReason(true);
    } else {
      setEnableOtherReason(false);
    }
  }, [qcReason]);

  useEffect(() => {
    const elements = document.querySelectorAll('.react-select-modal__single-value');
    //console.log("--- Elements ----",elements)
    if (elements.length > 0) {
      elements.forEach(element => {
        element.style.color = getThemeColor("primary-color");
      });
    }
  }, [document.querySelectorAll('.react-select-modal__single-value')]);

  return (
    <>
      <div
        style={{
          height: "60%",
          width: "60%",
        }}
      >
        {/* <Modal
          isOpen={true}
          titleAriaId="id"
          scrollableContentClassName={"stop-scroll-for-modal"}
        > */}
        <QCModalHeader
          heading={t("QC.qc-return-modal-heading")}
          handleCancel={handleCancel}
        />
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            background: getThemeColor("modal-body"),
            color: getAlterColor("#FFF","#000"),
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              paddingLeft: "20px",
              paddingTop: "5px",
            }}
          >
            <span
              style={{
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "16px",
                // color: "rgb(255,255,255,0.8)",
                marginRight: "10px",
              }}
            >
              {patientStudyData?.patientName}
            </span>
            <span
              style={{
                fontWeight: "400",
                fontSize: "10px",
                lineHeight: "16px",
                // color: "rgb(255,255,255,0.5)",
              }}
            >
              {t("QC.id")} {patientStudyData?.patientId}
            </span>
          </div>
          <div
            style={{
              width: "90%",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              paddingTop: "30px",
              paddingLeft: "20px",
            }}
          >
            <span style={{ width: "50%" }}>{t("QC.qc-reason-label")}</span>
            <div style={{ width: "36%" }}>
              <QCFailReasons setQcReason={setQcReason} qcReason={qcReason} />
            </div>
          </div>
          <div
            style={{
              width: "90%",
              display: `${enableOtherReason ? "flex" : "none"}`,
              justifyContent: "flex-start",
              alignItems: "center",
              paddingTop: "30px",
              paddingLeft: "20px",
            }}
          >
            <span style={{ width: "50%" }}>{t("QC.other-label")}</span>
            <div style={{ width: "50%" }}>
              <TextField
                name="otherReason"
                placeholder={t("QC.other-reason-placeholder")}
                onChange={handleChange}
                // value = {otherReason}
                disabled={!enableOtherReason}
              />
            </div>
          </div>
          <div
            style={{
              width: "90%",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              paddingTop: "30px",
              paddingLeft: "20px",
              paddingBottom: "30px",
            }}
          >
            <span style={{ width: "50%" }}>{t("QC.assign-radiologist")}</span>
            <div style={{ width: "36%" }}>
              <Select
                classNamePrefix="react-select-modal"
                options={qcProviderList}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    background: state.isFocused ? "black" : "rgb(32, 31, 30)",
                    color: getThemeColor("primary-color"),
                    backgroundColor: getThemeColor("action-details-background"),
                    border: BORDER.TAB,
                  }),
                  menu: (baseStyles,state) => ({
                    ...baseStyles,
                    width: "100% !important",
                    backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
                        '&:hover': {
                          backgroundColor: `${getThemeColor("popup-hover")} !important`,
                        },
                  }),
                  menuList: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
                    '&:hover': {
                      backgroundColor: `${getThemeColor("popup-hover")} !important`,
                    },
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    color: getThemeColor("primary-color"),
                    backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
                    '&:hover': {
                      backgroundColor: `${getThemeColor("popup-hover")} !important`,
                    },
                  }),
                }}
                placeholder={t("QC.select-radiologist")}
                onChange={(item) => handleProviderDropDownClick(item)}
              />
              {/* <Dropdown
                placeholder={t("QC.select-radiologist")}
                options={qcProviderList}
                styles={dropDownStyles}
                onChange={handleProviderDropDownClick}
              /> */}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: `${isError ? "flex" : "none"}`,
              justifyContent: "center",
              alignItems: "center",
              paddingBottom: "10px",
            }}
          >
            <span style={{ color: "red" }}>{errorMessage}</span>
          </div>
        </div>
        <QCModalFooter
          PrimaryButtonList={PrimaryButtonList}
          DefaultButtonList={DefaultButtonList}
        />
        {/* </Modal> */}
      </div>
    </>
  );
};

export default QCFailModal;
